export const port = import.meta.env.VITE_DEV_API_SERVER_PORT ?? 3000;
export const environment = import.meta.env.MODE;
export const encryptedJwtPublicKey = import.meta.env.VITE_ENCRYPTED_JWT_PUBLIC_KEY;
